export enum ColumnSpecDataTypeEnum {
    Text = "Text",
    Decimal = "Decimal",
    Bigint = "Bigint",
    Int = "Int",
    Money = "Money",
    Datetime = "Datetime",
}